/**
 * Infer planner server_environment from NEMT API base URL.
 * Portal redirect `env` is set server-side on OAuth; users cannot toggle dev/live manually.
 */
export function inferServerEnvironmentFromNemtBaseUrl(baseUrl) {
  const s = String(baseUrl || '').trim().toLowerCase();
  if (s && s.includes('dev')) {
    return 'dev';
  }
  return 'live';
}

/** Read-only label for UI — prefers base URL inference when URL is present. */
export function displayedServerEnvironment(nemtBaseUrl, storedEnvironment) {
  const base = String(nemtBaseUrl || '').trim();
  if (base) return inferServerEnvironmentFromNemtBaseUrl(base);
  return storedEnvironment === 'dev' ? 'dev' : 'live';
}
